import { Slide } from '@/components/core/Slide';
import { WebContent } from '@/components/web/WebContent';
import audioFile from './20-gans.mp3';

const transcript = `
  Uhmmm, waar zal ik beginnen... Het publiek is niet allemaal thuis in machine learning en zo.

  Je zegt altijd dat je het omdraaien van de image labeler zo'n briljante anekdote vindt, maar dan moet ik dus wat 
  over GANs vertellen. Is dat goed?
`;

// Jonathan: Ja maar houd het simpel.

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} visualizer="bottom-right" networkBackground="full">
      <div className="flex flex-col items-center justify-center h-full">
        <WebContent
          animation={{
            type: 'fade',
            delay: 5000,
            duration: 1000,
          }}
        >
          <h1 className="text-6xl mb-8">GAN</h1>
        </WebContent>
        <WebContent
          animation={{
            type: 'fade',
            delay: 5500,
            duration: 1200,
          }}
        >
          <p className="text-2xl text-center opacity-80">Generative Adversarial Network</p>
        </WebContent>
      </div>
    </Slide>
  );
};
